import List from 'src/storage/treatmentsList';
import { validate } from 'src/helpers/validation';

class TreatmentsAnalysesModel extends List {
  id = 'TreatmentsAnalyses';
  defaultState = () => ({
    current: 'recent'
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'analyse/refresh',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'analyse/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'analyse/search',
      validation: {
        partnerId: 'userId',
        query: 'string',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    create: {
      url: 'analyse/create',
      validation: {
        partnerId: 'userId',
        title: 'analyseTitle',
        files: 'analyseFile',
        msgType: 'string'
      },
      cancellable: true
    },
    edit: {
      url: 'analyse/edit',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    updatePrivacySettings: {
      url: '/analyse/update/privacySettings',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    remove: {
      url: '/analyse/remove',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    aiInterpret: {
      url: '/analyse/ai_interpret',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    'foxsocket:message:analyse': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  filterItem = (data) => {
    if (data.from !== this.userId) return false;
    return this.onFilterOtherItem(data);
  };

  listParams(loadMore) {
    const req = {
      partnerId: 0,
      skip: 0,
      limit: this.listLimit
    };
    const query = this.listInput('search');
    this.log('listParams query', query, this);
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  create = (cb) => {
    let { title, files } = this.getCurrent();
    let req = {
      partnerId: 0,
      title,
      files,
      msgType: 'analyse'
    };
    this.api('create', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddAnalyse();
        this.onFilterOtherItem(data);
      }
    });
  };
  edit = (cb) => {
    let { title, files, media, editId } = this.getCurrent();
    let req = {
      id: editId,
      title,
      media,
      files
    };

    let invalid = {
      length: 0,
      title: validate('title', title),
      files: req.media.length > 0 ? null : validate('analyseFile', files)
    };

    invalid.length = Object.values(invalid).filter((v) => !!v).length;

    if (invalid.length > 0) {
      return this.setInvalidApi('edit', invalid);
    }

    this.api('edit', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddAnalyse();
        this.filterItem(data);
      }
    });
  };

  resetAddAnalyse = (item) => {
    this.resetApiState('edit');
    this.resetApiState('create');
    this.setListState({
      editId: item?.id,
      title: item?.text || '',
      media: item?.media || [],
      files: []
    });
  };

  updatePrivacySettings = ({ id, privacySettings, cb }) => {
    let req = {
      id,
      privacySettings
    };
    this.api('updatePrivacySettings', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.onFilterOtherItem(data);
      }
    });
  };

  aiInterpret = ({ id, cb }) => {
    let req = {
      id
    };
    this.api('aiInterpret', req, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };

  delete = (item, cb) => {
    this.api('remove', { id: item.id }, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };

  canModify = (item) => {
    const createdById = !item.createdById ? item.from : item.createdById;
    return createdById === this.state.user?.id;
  };
}

const model = new TreatmentsAnalysesModel();
export default model;
